/* =================================================
   ZAPF & ZUNDER – Cart Lock v1.1 (14.05.2026)
   =================================================
   v1.1: Selektoren für Pitch-Theme korrigiert
   (tr.cart-items__table-row als Cart-Item-Container)
   ================================================= */

(function() {
  'use strict';

  const LOCKED_TITLE_KEYWORDS = [
    'An- & Abfahrtpauschale',
    'An- &amp; Abfahrtpauschale',
    'Anfahrtspauschale',
    'Mehrwegbecher'
  ];

  const LOCKED_PROPERTY_KEYWORDS = ['Zugehörig zu', 'Zugehoerig zu'];

  const BUNDLE_TITLE_KEYWORDS = [
    'Bundle Paket',
    'Angebot S',
    'Angebot M',
    'Angebot L'
  ];

  const LOCK_NOTE_TEXT = '🔒 Teil deines Bundles – nicht einzeln entfernbar';

  function getText(el) {
    return (el && el.textContent ? el.textContent : '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function matchesAny(text, keywords) {
    return keywords.some(function(kw) { return text.indexOf(kw) !== -1; });
  }

  function isLockedItem(item) {
    const text = getText(item);
    return matchesAny(text, LOCKED_TITLE_KEYWORDS) ||
           matchesAny(text, LOCKED_PROPERTY_KEYWORDS);
  }

  function isBundleItem(item) {
    const text = getText(item);
    return matchesAny(text, BUNDLE_TITLE_KEYWORDS);
  }

  function findCartItems() {
    const selectors = [
      'tr.cart-items__table-row',
      '.cart-items__table-row',
      'cart-line-item',
      '[id^="CartItem-"]',
      '[id^="CartDrawer-Item-"]',
      '.cart-item',
      'tr.cart-item',
      'li.cart-item',
      '[data-line-item]'
    ];
    const found = new Set();
    selectors.forEach(function(sel) {
      try {
        document.querySelectorAll(sel).forEach(function(el) { found.add(el); });
      } catch(e) {}
    });
    return Array.from(found);
  }

  function lockItemUI(item) {
    if (item.dataset.zuzLocked) return;
    item.dataset.zuzLocked = '1';

    // Remove-Buttons ausblenden (alle möglichen Varianten)
    const removeSelectors = [
      'cart-remove-button',
      'button[name="remove"]',
      'a[href*="/cart/change"][href*="quantity=0"]',
      'a[href*="/cart/remove"]',
      'button[aria-label*="entfern" i]',
      'button[aria-label*="remove" i]',
      'button[aria-label*="lösch" i]',
      'a[aria-label*="entfern" i]',
      'a[aria-label*="remove" i]',
      '[class*="cart-remove"]',
      '[class*="remove-button"]',
      '[class*="cart-item__remove"]',
      '[class*="cart-items__remove"]'
    ];
    removeSelectors.forEach(function(sel) {
      try {
        item.querySelectorAll(sel).forEach(function(el) {
          el.style.display = 'none';
          el.style.visibility = 'hidden';
        });
      } catch(e) {}
    });

    // Quantity-Inputs deaktivieren
    item.querySelectorAll('input[type="number"], input[name="updates[]"]').forEach(function(input) {
      input.disabled = true;
      input.readOnly = true;
      input.style.pointerEvents = 'none';
      input.style.opacity = '0.6';
    });

    // +/- Buttons deaktivieren
    const qtyBtnSelectors = [
      'button[name="plus"]',
      'button[name="minus"]',
      'quantity-input button',
      'quantity-selector button',
      'button[aria-label*="quantity" i]',
      'button[aria-label*="menge" i]',
      '[class*="quantity-button"]',
      '[class*="quantity__button"]'
    ];
    qtyBtnSelectors.forEach(function(sel) {
      try {
        item.querySelectorAll(sel).forEach(function(btn) {
          btn.disabled = true;
          btn.style.opacity = '0.3';
          btn.style.pointerEvents = 'none';
        });
      } catch(e) {}
    });

    // Hinweistext
    if (!item.querySelector('.zuz-lock-note')) {
      const note = document.createElement('div');
      note.className = 'zuz-lock-note';
      note.style.cssText = 'font-size: 11px; color: #888; margin-top: 6px; font-style: italic; line-height: 1.4;';
      note.textContent = LOCK_NOTE_TEXT;
      item.appendChild(note);
    }
  }

  function processCart() {
    const items = findCartItems();
    let lockedCount = 0;
    items.forEach(function(item) {
      if (isLockedItem(item) && !isBundleItem(item)) {
        lockItemUI(item);
        lockedCount++;
      }
    });
    if (items.length > 0) {
      console.log('[ZuZ Cart-Lock] Items gefunden: ' + items.length + ', gelockt: ' + lockedCount);
    }
  }

  function setupBundleRemovalHandler() {
    document.addEventListener('click', function(e) {
      const removeBtn = e.target.closest(
        'cart-remove-button, button[name="remove"], ' +
        'a[href*="/cart/change"][href*="quantity=0"], ' +
        'a[href*="/cart/remove"], ' +
        'button[aria-label*="entfern" i], ' +
        'button[aria-label*="remove" i], ' +
        'a[aria-label*="entfern" i], ' +
        'a[aria-label*="remove" i]'
      );
      if (!removeBtn) return;

      const cartItem = removeBtn.closest(
        'tr.cart-items__table-row, .cart-items__table-row, ' +
        'cart-line-item, [id^="CartItem-"], [id^="CartDrawer-Item-"], ' +
        '.cart-item, [data-line-item], tr, li'
      );
      if (!cartItem || !isBundleItem(cartItem)) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (confirm(
        'Möchtest du das gesamte Bundle entfernen?\n\n' +
        'Alle dazugehörigen Positionen (Anfahrt, Becher, Getränke) werden ebenfalls aus dem Warenkorb entfernt.'
      )) {
        fetch('/cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
        })
          .then(function() { location.reload(); })
          .catch(function() { location.reload(); });
      }
      return false;
    }, true);
  }

  function init() {
    console.log('[ZuZ Cart-Lock] v1.1 initialized');
    processCart();
    setupBundleRemovalHandler();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  ['cart:updated', 'cart:refreshed', 'cart-drawer:opened',
   'cart:rendered', 'shopify:section:load', 'cart:open']
    .forEach(function(evt) {
      document.addEventListener(evt, processCart);
    });

  let mutationTimer;
  const observer = new MutationObserver(function() {
    clearTimeout(mutationTimer);
    mutationTimer = setTimeout(processCart, 150);
  });
  observer.observe(document.body, { childList: true, subtree: true });

})();